import { Icon } from '@eliadmin/core/src/components/nt/ui/icon';
import { cn } from '@eliadmin/core/src/utils/style-utils';

const MAX_RATING = 5;

/** „4,5“ / „5“ typed in the administration or a number from the API; null when it is not a rating. */
export function parseRating(value: string | number | null | undefined) {
  const rating =
    typeof value === 'number' ? value : parseFloat(String(value ?? '').replace(',', '.'));
  return Number.isFinite(rating) && rating > 0 ? Math.min(rating, MAX_RATING) : null;
}

/**
 * Figma „Stars“ (review 46:4723): five 20 px stars 2 px apart, filled in CMYK yellow. The value is
 * rounded to whole stars; the label carries the exact value for screen readers.
 */
export function RatingStars({
  rating,
  label,
  size = 20,
  className,
}: {
  rating: number;
  /** Accessible text, e.g. „Hodnotenie 4,5/5“. */
  label: string;
  size?: number;
  className?: string;
}) {
  const filled = Math.round(rating);

  return (
    <span role="img" aria-label={label} className={cn('flex gap-0.5', className)}>
      {Array.from({ length: MAX_RATING }, (_, index) => (
        <Icon
          key={index}
          name="star"
          size={size}
          className={index < filled ? 'text-[#FFD200]' : 'text-[#E2E5DF]'}
        />
      ))}
    </span>
  );
}

/** „Hodnotenie 4,5/5“ in the number format of the locale. */
export function ratingLabel(prefix: string, rating: number, locale: string) {
  return `${prefix} ${rating.toLocaleString(locale)}/${MAX_RATING}`;
}
